import React, { useContext, useEffect, useState } from "react";
import useObtenerSubsecciones from "../js/translations/useObtenerSubsecciones";
import { store } from "./Store";
import { useLanguage } from "../hooks/use-language";

export const BookDownloadingPopUp = () => {
    const lang = useLanguage();
	const { textosSubSecciones: textos } = useObtenerSubsecciones("global");
	const { state, dispatch } = useContext(store);
	const [liveMessage, setLiveMessage] = useState("");

	const errorMessage =
		textos?.popup_descargando_libro?.error_descargando ||
		"Ocurrió un error en la descarga del libro, vuelve a intentarlo.";

	const warningMessage =
		textos?.popup_descargando_libro?.advertencia ||
		"No cierres esta ventana hasta que se descargue el libro.";

	const downloadingText = textos?.popup_descargando_libro?.descargando || "Descargando";
    const downloadedText = {
        en: "Downloaded",
        es: "Descargado"
    }
    const downloadingAriaLabel = {
        en: "Downloading",
        es: "Descarga de "
    }
	useEffect(() => {
		let timer = setTimeout(() => {
			if (state?.errorDescargandoLibro) {
				dispatch({ type: "CHANGE_VALUE", property: "descargando", value: false });
			}
		}, 5000);

		return () => {
			clearTimeout(timer);
		};
	}, [state?.errorDescargandoLibro, dispatch]);

	useEffect(() => {
		if (state?.errorDescargandoLibro) {
			setLiveMessage(errorMessage);
			return;
		}

		if (state?.descargando) {
			setLiveMessage(
				`${downloadingText} ${state.tituloDescargando || ""}. ${state.progresoDescarga || "0%"}`,
			);
			return;
		}

		setLiveMessage("");
	}, [
		state?.errorDescargandoLibro,
		state?.descargando,
		state?.tituloDescargando,
		state?.progresoDescarga,
		errorMessage,
		downloadingText,
	]);

	return (
		<>
			{/* Región viva solo para lectores */}
			{state?.errorDescargandoLibro ? (
				<div role="alert" aria-atomic="true" className="sr-only">
					{liveMessage}
				</div>
			) : (
				<div role="status" aria-live="polite" aria-atomic="true" className="sr-only">
					{liveMessage}
				</div>
			)}

			{/* UI visual */}
			<div className="book-download-progress pt-3 pb-4">
				{state?.errorDescargandoLibro ? (
					<div className="mx-auto book-download-alert py-2 mb-2">
						<p>{errorMessage}</p>
					</div>
				) : (
					<>
						<div className="mx-auto book-download-alert py-2 mb-2">
							<p>{warningMessage}</p>
						</div>

						<div className="mx-auto book-download-info">
							<div className="d-flex mb-2 align-items-center">
								<div
									className="progress col-12 px-0"
									role="progressbar"
									aria-valuemin={0}
									aria-valuemax={100}
									aria-valuenow={parseInt(state.progresoDescarga, 10) || 0}
									aria-valuetext={`${state.progresoDescarga} ${downloadedText[lang]}`}
									aria-label={`${downloadingAriaLabel[lang]} ${state.tituloDescargando || "libro"}`}
								>
									<div
										className="progress-bar"
										style={{ width: `${state.progresoDescarga}` }}
										aria-hidden="true"
									/>
								</div>
							</div>

							<p>
								{downloadingText} {state.tituloDescargando}{" "}
								<span className="onsecondary-inverse--color bold">
									{state.progresoDescarga}
								</span>
							</p>
						</div>
					</>
				)}
			</div>
		</>
	);
};
